import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getAssetLink } from '../../../../helpers/get-asset-link'

const AssigneeCell = ({ assignee }) => {
  const { t } = useTranslation(['maintenance'])
  return assignee ? (
    <div className="ctp-maintenance-requests-list__address-cell">
      <img
        src={getAssetLink({
          path: 'chitown-avatar/avatar',
          file: assignee?.user?.avatar,
          fallback: { file: 'avatar.png' },
        })}
        alt={t('maintenance:requests.cells.assigneeAvatarAlt')}
      />
      <div className="ctp-maintenance-requests-list__client-info-wrapper">
        <span>
          {assignee.user.firstName} {assignee.user.lastName}
        </span>
        <span className="ctp-maintenance-requests-list__address-info">{assignee.user.email}</span>
      </div>
    </div>
  ) : (
    <span>-</span>
  )
}

AssigneeCell.propTypes = {
  assignee: PropTypes.object,
}

export default AssigneeCell
